<div class="tile-padding-first tile-padding">

  <div class="flex-search-container" [class.filter-bar]="filtersEnabled">
    <div class="flex-search-sub filter-bar__group">

      <div class="flex-column filter-bar__field">
        <label class="field__label">Search</label>
        <app-typeahead [(ngModel)]="searchTerm"
          (keyup.enter)="search()" placeholder="Name or email"
          [enabled]="autocompleteEnabled" [source]="searchUserSuggestions" [displayWith]="suggestionUserName"
          [secondaryWith]="suggestionDetail" [valueWith]="suggestionSearchText"></app-typeahead>
      </div>

      <div class="flex-column filter-bar__field">
        <label class="field__label">Sign-in</label>
        <select class="field__control" [(ngModel)]="authMethod" (change)="search()">
          <option value="">Any</option>
          <option value="both">Password and Entra</option>
          <option value="password">Password only</option>
          <option value="entra">Entra only</option>
          <option value="none">Neither</option>
        </select>
      </div>

      <ng-container *appFeatureSwitch="filtersKey">
        <div class="flex-column filter-bar__field">
          <label class="field__label">Role</label>
          <select class="field__control" [(ngModel)]="roleCode" (change)="search()" data-filter="role">
            <option value="">Any</option>
            @for (role of roles; track role.id) {
              <option [value]="role.code">{{role.description || role.code}}</option>
            }
          </select>
        </div>

        <div class="flex-column filter-bar__field">
          <label class="field__label">Status</label>
          <select class="field__control" [(ngModel)]="activeFilter" (change)="search()" data-filter="active">
            <option value="">Any</option>
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
        </div>

        <div class="flex-column filter-bar__field">
          <label class="field__label">Type</label>
          <select class="field__control" [(ngModel)]="internalFilter" (change)="search()" data-filter="internal">
            <option value="">Any</option>
            <option value="true">Internal</option>
            <option value="false">External</option>
          </select>
        </div>

        <div class="flex-column filter-bar__field">
          <label class="field__label">Last sign-in</label>
          <select class="field__control" [(ngModel)]="lastSignInFilter" (change)="search()" data-filter="last-sign-in">
            <option value="">Any</option>
            <option value="within:7">In the last 7 days</option>
            <option value="within:30">In the last 30 days</option>
            <option value="over:30">Not for 30+ days (or never)</option>
            <option value="over:90">Not for 90+ days (or never)</option>
            <option value="over:180">Not for 180+ days (or never)</option>
            <option value="never">Never</option>
          </select>
        </div>

        <div class="flex-column filter-bar__group">
          <app-brand-filter class="filter-bar__field" [companyIds]="companyIds" (companyIdsChange)="companyIds = $event; search()"></app-brand-filter>
        </div>
      </ng-container>

      <div class="flex-column filter-bar__field filter-bar__field--check">
        <label class="field__checkbox">
          <input type="checkbox" [(ngModel)]="includeDeleted" (change)="search()" /> Include deleted
        </label>
      </div>

      @if (!filtersEnabled) {
        <div class="flex-column">
          <div class="btn-align">
            <button class="btn btn-primary tw:mr-1" type="button" (click)="search()">Search</button>
          </div>
        </div>
      }

    </div>

    @if (filtersEnabled) {
      <div class="filter-bar__actions">
        <div class="filter-bar__buttons">
          <app-filter-clear-all (clear)="clearAll()"></app-filter-clear-all>
          <button class="btn btn-primary" type="button" (click)="search()">Search</button>
        </div>
      </div>
    }
  </div>

  <app-data-table
    [columns]="columns"
    [data]="rows"
    [serverSide]="true"
    [totalCount]="totalCount"
    [pageSize]="pageSize"
    [sortField]="sortField"
    [sortDir]="sortDir"
    [loading]="loading"
    [emptyMessage]="errorMsg || 'No records found'"
    (pageChange)="onPageChange($event)"
    (sortChange)="onSortChange($event)">

    <ng-template appColumnCell="status" let-element>
      @if (element.deleted) {
        <span class="tw:text-red-600">Deleted</span>
      } @else if (!element.active) {
        <span class="tw:text-amber-600">Pending</span>
      } @else {
        <span class="tw:text-green-600">Active</span>
      }
    </ng-template>

    <ng-template appColumnCell="name" let-element>
      {{element.firstName}} {{element.lastName}}
    </ng-template>

    <ng-template appColumnCell="applicationId" let-element>
      {{element.applicationId | brandShortCode: brands}}
    </ng-template>

    <ng-template appColumnCell="type" let-element>
      {{element.isInternal ? 'Internal' : 'External'}}
    </ng-template>

    <ng-template appColumnCell="auth" let-element>
      @if (element.hasPassword && element.hasEntraIdentity) {
        <span title="Can sign in on the login form and through Entra">Password and Entra</span>
      } @else if (element.hasEntraIdentity) {
        <span title="Can sign in through Entra only">Entra only</span>
      } @else if (element.hasPassword) {
        <span title="Can sign in on the login form only">Password only</span>
      } @else {
        <span class="tw:text-red-600" title="No password and no linked Entra identity — this user cannot sign in at all">Neither</span>
      }
    </ng-template>

    <ng-template appColumnCell="lastSignInUtc" let-element>
      @if (element.lastSignInUtc) {
        <span [title]="element.lastSignInUtc | date:'dd/MM/yyyy HH:mm:ss':'UTC'">{{element.lastSignInUtc | date:'dd/MM/yyyy HH:mm'}}</span>
      } @else {
        <span class="tw:text-gray-500" title="No sign-in recorded">Never</span>
      }
    </ng-template>

    <ng-template appColumnCell="mfa" let-element>
      <label class="field__checkbox">
        <input type="checkbox" [checked]="element.mfaRequired" [disabled]="!canEdit || !isAdmin"
          (change)="toggleMfa(element, $event.target.checked)" />
      </label>
    </ng-template>

    <ng-template appColumnCell="action" let-element>
      @if (canManage(element)) {
        <button class="btn btn-link" type="button" title="Edit" (click)="editUser(element)">
          <i class="las la-edit"></i>
        </button>
        <button class="btn btn-link" type="button" [title]="element.active ? 'Disable' : 'Enable'"
          (click)="toggleActive(element)">
          <i class="las" [ngClass]="element.active ? 'la-user-slash' : 'la-user-check'"></i>
        </button>
        @if (element.hasPendingActivation) {
          <button class="btn btn-link" type="button" title="Resend activation" (click)="resendActivation(element)">
            <i class="las la-paper-plane"></i>
          </button>
        }
        <button class="btn btn-link" type="button" title="Send password reset" (click)="sendPasswordReset(element)">
          <i class="las la-key"></i>
        </button>
        <button class="btn btn-link" type="button" title="Delete" (click)="deleteUser(element)">
          <i class="las la-trash"></i>
        </button>
      }
    </ng-template>

  </app-data-table>

</div>
